import React from 'react';

import { Card, Heading } from '@aws-amplify/ui-react';
import NoSignInAppBar from '@components/parts/appbar/NoSignInAppBar';

type OwnProps = {
  title?: string;
  children?: any;
};

const PageBaseNoSignIn = ({ title, children }: OwnProps) => (
  <div>
    <NoSignInAppBar />
    <Card>
      <Heading level={5} color="primary" style={{ fontWeight: 'bold' }}>
        {title}
      </Heading>
    </Card>
    <div>{children}</div>
  </div>
);

PageBaseNoSignIn.defaultProps = {
  title: '',
  children: <p />
};

export default PageBaseNoSignIn;
